import request from '@/utils/request'

/**
 * 添加应用
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appAdd(data) {
  return request({
    type: 'base',
    url: 'app/add',
    method: 'post',
    data
  })
}
/**
 * 应用上下架状态修改
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appControlUpdate(data) {
  return request({
    type: 'base',
    url: 'app/control/update',
    method: 'post',
    data
  })
}
/**
 * 删除应用
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appDelete(data) {
  return request({
    type: 'base',
    url: 'app/delete',
    method: 'post',
    data
  })
}
/**
 * 获取应用详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appDetailGet(data) {
  return request({
    type: 'base',
    url: 'app/detail/get',
    method: 'post',
    data
  })
}
/**
 * 获取应用分组和应用列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appDetailListGet(data) {
  return request({
    type: 'base',
    url: 'app/detail/list/get',
    method: 'post',
    data
  })
}
/**
 * 添加项目/产品
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appGroupAdd(data) {
  return request({
    type: 'base',
    url: 'app/group/add',
    method: 'post',
    data
  })
}
/**
 * 删除项目/产品
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appGroupDelete(data) {
  return request({
    type: 'base',
    url: 'app/group/delete',
    method: 'post',
    data
  })
}
/**
 * 获取项目/产品详情
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appGroupGet(data) {
  return request({
    type: 'base',
    url: 'app/group/get',
    method: 'post',
    data
  })
}
/**
 * 获取项目/产品列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appGroupList(data) {
  return request({
    type: 'base',
    url: 'app/group/list',
    method: 'post',
    data
  })
}
/**
 * 编辑项目/产品
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appGroupUpdate(data) {
  return request({
    type: 'base',
    url: 'app/group/update',
    method: 'post',
    data
  })
}
/**
 * 获取应用列表
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appListGet(data) {
  return request({
    type: 'base',
    url: 'app/list/get',
    method: 'post',
    data
  })
}
/**
 * 编辑应用
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function appUpdate(data) {
  return request({
    type: 'base',
    url: 'app/update',
    method: 'post',
    data
  })
}
/**
 * 获取应用列表（oauth）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthApplicationListGet(data) {
  return request({
    type: 'base',
    url: 'oauth/application/list/get',
    method: 'post',
    data
  })
}
/**
 * 根据用户、应用编号获取人员列表（oauth）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthApplicationMemberGet(data) {
  return request({
    type: 'base',
    url: 'oauth/application/member/get',
    method: 'post',
    data
  })
}
/**
 * 根据组织、应用编号获取人员列表（oauth）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthApplicationMemberListGet(data) {
  return request({
    type: 'base',
    url: 'oauth/application/member/list/get',
    method: 'post',
    data
  })
}
/**
 * 根据clientId获取应用（oauth）
 * @author: zhangkang
 * @createDate: 2021/01/19
 * @param data {Object} 参数
 */
export function oauthApplicationTokenGet(data) {
  return request({
    type: 'base',
    url: 'oauth/application/token/get',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/App.js